import angular from 'angular';

import { FiltersComponent } from './filters.component';

const MODULE_NAME = 'app.pickups.filters';

angular.module(MODULE_NAME, ['app.pickups']).component('esPickupsFilters', FiltersComponent);

export default MODULE_NAME;
